import { defineComponent as a, withDirectives as l, openBlock as o, createElementBlock as s, normalizeClass as c, createElementVNode as n, toDisplayString as r, vShow as i, createStaticVNode as d } from "vue";
const p = /* @__PURE__ */ d('<div class="loader-image"><svg class="spinner" viewBox="0 0 50 50"><circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle></svg><svg class="spinner-small" viewBox="0 0 50 50"><circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle></svg></div>', 1), m = /* @__PURE__ */ a({
  __name: "Loader",
  props: {
    show: { type: Boolean },
    theme: { default: "grey" },
    text: { default: "loader.text" }
  },
  setup(e) {
    return (t, h) => l((o(), s("div", {
      class: c("ap-loader ap-loader_theme-" + e.theme)
    }, [
      p,
      n("span", null, r(t.$t(e.text)), 1)
    ], 2)), [
      [i, e.show]
    ]);
  }
});
const _ = {
  install: (e) => {
    e.component("ApLoader", m);
  }
};
export {
  m as ApLoader,
  _ as default
};
